/** JustWatch types */
export enum JustWatchObjectType {
  movie = 'movie',
  show = 'show',
  showSeason = 'show_season',
  showEpisode = 'show_episode'
}

export enum JustWatchOfferType {
  standard = 'standard',
  aggregated = 'aggregated'
}

export enum JustWatchOfferMonetizationType {
  none = 'none',
  cinema = 'cinema',
  buy = 'buy',
  rent = 'rent',
  free = 'free',
  paid = 'paid',
  fast = 'fast',
  flatrate = 'flatrate',
  flatrateAndBuy = 'flatrate_and_buy',
  ads = 'ads'
}

export enum JustWatchOfferPresentationType {
  sd = 'sd',
  hd = 'hd',
  '4k' = '4k',
  bluray = 'bluray',
  bluray4k = 'bluray_4k',
  dvd = 'dvd',
  diskBundle = 'disk_bundle',
  canvas = 'canvas'
}

export enum JustWatchReleaseType {
  theatrical = 'theatrical',
  digital = 'digital'
}

export enum JustWatchExternalIdProvider {
  imdb = 'imdb',
  tmdb = 'tmdb'
}

/** TMDB types */
export enum TmdbObjectType {
  movie = 'movie',
  series = 'series',
  season = 'season',
  episode = 'episode',
  person = 'person'
}

export enum TmdbImageType {
  backdrops = 'backdrops',
  posters = 'posters',
  logos = 'logos',
  still = 'still',
  profile = 'profile'
}
